import React from "react"
import { Col } from "react-bootstrap"

export const CompanyCardSkeletonShimmer = ({ count = 8 }) => {
  return (
    <div className="row g-4" style={{ marginBottom: "80px" }}>
      {[...Array(count)].map((_, index) => (
        <Col xxl={3} xl={4} md={6} key={index}>
          <div className="card border h-100">
            <div className="card-body d-flex flex-column p-2">
              {/* Header Section */}
              <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom row-gap-2">
                <div className="d-flex align-items-center flex-grow-1 me-2" style={{ minWidth: 0 }}>
                  {/* Avatar */}
                  <div
                    className="rounded-circle flex-shrink-0 me-2"
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: "#f0f0f0",
                      background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "pulse-shimmer 1.5s infinite linear"
                    }}
                  ></div>
                  
                  <div style={{ minWidth: "0.5rem", flex: 1 }}>
                    {/* Company Name */}
                    <div
                      className="mb-2"
                      style={{
                        width: "70%",
                        height: "20px",
                        borderRadius: "4px",
                        backgroundColor: "#f0f0f0",
                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "pulse-shimmer 1.5s infinite linear"
                      }}
                    ></div>
                    
                    {/* Rating */}
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "80px",
                          height: "12px",
                          borderRadius: "4px",
                          backgroundColor: "#f0f0f0",
                          background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                          backgroundSize: "200% 100%",
                          animation: "pulse-shimmer 1.5s infinite linear",
                          animationDelay: "0.2s"
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Dropdown Menu */}
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "4px",
                    backgroundColor: "#f0f0f0",
                    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                    backgroundSize: "200% 100%",
                    animation: "pulse-shimmer 1.5s infinite linear"
                  }}
                ></div>
              </div>

              {/* Contact Information */}
              <div className="d-block mb-1 mx-1">
                <div className="d-flex flex-column mb-0">
                  {/* Email */}
                  <div
                    className="mb-2"
                    style={{
                      width: "85%",
                      height: "14px",
                      borderRadius: "4px",
                      backgroundColor: "#f0f0f0",
                      background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "pulse-shimmer 1.5s infinite linear"
                    }}
                  ></div>
                  
                  {/* Phone */}
                  <div
                    className="mb-2"
                    style={{
                      width: "70%",
                      height: "14px",
                      borderRadius: "4px",
                      backgroundColor: "#f0f0f0",
                      background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "pulse-shimmer 1.5s infinite linear",
                      animationDelay: "0.1s"
                    }}
                  ></div>
                  
                  {/* Address */}
                  <div
                    style={{
                      width: "90%",
                      height: "14px",
                      borderRadius: "4px",
                      backgroundColor: "#f0f0f0",
                      background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "pulse-shimmer 1.5s infinite linear",
                      animationDelay: "0.2s"
                    }}
                  ></div>
                </div>
              </div>

              {/* Footer */}
              <div className="d-flex justify-content-between align-items-center row-gap-2 border-top pt-3 mt-auto">
                {/* Social Icons */}
                <div className="d-flex align-items-center">
                  {[...Array(4)].map((_, iconIndex) => (
                    <div
                      key={iconIndex}
                      className="me-1"
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        backgroundColor: "#f0f0f0",
                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "pulse-shimmer 1.5s infinite linear",
                        animationDelay: `${iconIndex * 0.1}s`
                      }}
                    ></div>
                  ))}
                </div>

                {/* User Avatar */}
                <div className="d-flex align-items-center mt-2 me-1">
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      backgroundColor: "#f0f0f0",
                      background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "pulse-shimmer 1.5s infinite linear"
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      ))}
      
      {/* Pagination Skeleton */}
      <div
        style={{
          padding: "0.5rem 0",
          backgroundColor: "white",
          borderTop: "1px solid #e0e0e0",
          overflowX: "auto",
          width: "100%",
        }}
      >
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div className="pagination-left">
            <div
              style={{
                width: "150px",
                height: "20px",
                borderRadius: "4px",
                backgroundColor: "#f0f0f0",
                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "pulse-shimmer 1.5s infinite linear"
              }}
            ></div>
          </div>
          <div className="pagination-right d-flex gap-2 align-items-center">
            {/* Limit Select */}
            <div
              style={{
                width: "78px",
                height: "37px",
                borderRadius: "4px",
                backgroundColor: "#f0f0f0",
                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "pulse-shimmer 1.5s infinite linear"
              }}
            ></div>
            
            {/* Pagination Controls */}
            <div className="d-flex align-items-center gap-3">
              <div
                style={{
                  width: "200px",
                  height: "37px",
                  borderRadius: "4px",
                  backgroundColor: "#f0f0f0",
                  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                  backgroundSize: "200% 100%",
                  animation: "pulse-shimmer 1.5s infinite linear"
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}